/*
* Paredzēts, lai piem. tērzētavā (ievades laukam) būtu smaidiņi
*/
import React from 'react';

import ReactDOM from 'react-dom';
import EmoticonsContainer from '../emoticons/EmoticonsContainer.react';
import EmoticonsButton from '../emoticons/EmoticonsButton.react';
import GiphyButton from '../giphy/GiphyButton.react';
import Giphy from '../giphy/Giphy.react';

let $input = null; // ievades objekts (textarea)

class DiscussionsButtonBlock extends React.Component {
	state = {
	  emoticonsOpen: false,
	  giphyOpen: false,
	  userInput: '',
	};

	componentDidMount() {
	  const node = ReactDOM.findDOMNode(this);
	  if (node !== undefined) {
	    const $form = $(node).closest('form');
	    $input = $form.find('textarea');
	  }
	}

	toggleEmoticonsPanel = (event) => {
	  event.preventDefault();
	  this.setState({ emoticonsOpen: !this.state.emoticonsOpen });
	  if (this.state.emoticonsOpen == false) {
	    this.setState({ giphyOpen: false });
	  }
	};

	toggleGiphyPanel = (event) => {
	  event.preventDefault();
	  this.setState({ giphyOpen: !this.state.giphyOpen });
	  if (this.state.giphyOpen == false) {
	    this.setState({ emoticonsOpen: false });

	    $('.unveil-giphy').unveil();
	  }
	};

	addGif = (shortname) => {
	  if (this.props.addGif) {
	    this.props.addGif(shortname);
	  } else {
	    const $target = $input;

	    $target[0].focus();
	    const oldValue = $target.val();
	    const caretPos = $target[0].selectionStart;
	    const newValue = `${oldValue.substring(0, caretPos)} ${
	      shortname} ${
	      oldValue.substring(caretPos, oldValue.length)}`;
	    $target.val(newValue);
	    $target[0].selectionStart = $target[0].selectionEnd = caretPos + shortname.length + 2;
	    $target[0].focus();
	  }

	  this.setState({ giphyOpen: !this.state.giphyOpen });
	};

	render() {
	  return (
  <div>
    <EmoticonsButton toggleEmoticonsPanel={this.toggleEmoticonsPanel} />
    <EmoticonsContainer
      addEmoticon={this.props.addEmoticon}
      isOpen={this.state.emoticonsOpen}
      orientation="portrait"
    />

    <GiphyButton toggleGiphyPanel={this.toggleGiphyPanel} />
    <Giphy
      isOpen={this.state.giphyOpen}
      addGif={this.addGif}
      toggleGiphyPanel={this.toggleGiphyPanel}
    />
  </div>
	  );
	}
}

module.exports = DiscussionsButtonBlock;
